import ReceiptsView from './ReceiptsView';

// PortalFinance — the bottom bar's route into the receipt history.
//
// Deliberately a one-line wrapper. The same list is reachable from
// Account → Receipts in the side menu, and two copies of a receipt
// list is two places for the receipt dialog to drift. The component
// lives in ReceiptsView; this is just the door.
export default function PortalFinance() {
  return <ReceiptsView />;
}
